import { Api } from '../typings/api';
import Utils from './index';

const mergeObjectProperties = (object: {}, propertiesToUpdate: {}): {} => {
	if (!object || !propertiesToUpdate) {
		return object;
	}

	for (const key in propertiesToUpdate) {
		if (!propertiesToUpdate.hasOwnProperty(key)) {
			continue;
		}

		const updateValue = propertiesToUpdate[key];

		if (updateValue === undefined) {
			continue;
		}

		const currentValue = object[key];

		if (
			updateValue !== null
			&& typeof updateValue === 'object'
			&& !Array.isArray(updateValue)
			&& currentValue !== null
			&& typeof currentValue === 'object'
			&& !Array.isArray(currentValue)
		) {
			object[key] = mergeObjectProperties(currentValue, updateValue);
		} else {
			object[key] = updateValue;
		}
	}

	return object;
};

export const mergeGalleryConfig = (
	localConfig: Api.Config,
	remoteConfig: Api.Config,
): Api.Config => {
	const merged = Utils.deepCopy(localConfig) as Api.Config;

	mergeObjectProperties(merged, remoteConfig);
	merged.clientId = localConfig.clientId;
	merged.applicationGallery = localConfig.applicationGallery;

	return merged;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/galleryConfigMerge.ts